export default function Reaction0({
  size,
  color,
  className = "",
  onClick = () => {},
  active = false,
}) {
  return (
    <svg
      onClick={onClick}
      style={{
        cursor: "pointer",
        transition: "0.5s",
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        backgroundColor: active ? "#cc0c00" : "#ffffff",
        borderRadius: "50%",
      }}
      fill={active ? "#ffffff" : color}
      className={className}
      viewBox="0 0 64 64"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
    >
      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M32,3c16,0,29,13,29,29S48,61,32,61S3,48,3,32S16,3,32,3 M32,0C14.3,0,0,14.3,0,32s14.3,32,32,32
			s32-14.3,32-32S49.7,0,32,0L32,0z"
      />

      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M22.5,46.5c1.4-3.8,5.1-6.5,9.4-6.5c4.4,0,8.1,2.8,9.5,6.8"
      />

      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M16.5,21.1c-0.5,1.1-0.6,2.3-0.3,3.7c0.5,2.1,2.2,3.7,4.3,4.1c3.7,0.7,6.9-2.1,6.8-5.7c0,0,0,0,0,0l-9.7-2.6
		C17.1,20.4,16.6,20.7,16.5,21.1z"
      />

      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M47.5,21.1c0.5,1.1,0.6,2.3,0.3,3.7c-0.5,2.1-2.2,3.7-4.3,4.1c-3.7,0.7-6.9-2.1-6.8-5.7c0,0,0,0,0,0l9.7-2.6
		C46.9,20.4,47.4,20.7,47.5,21.1z"
      />

      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M47.3,5L48,8.4c0.3,1.5-0.7,3-2.2,3.3l-3.4,0.7"
      />
      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M52.1,4l0.7,3.4c0.3,1.5,1.8,2.5,3.3,2.2l3.4-0.7"
      />
      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M55.6,21l-0.7-3.4c-0.3-1.5,0.7-3,2.2-3.3l3.4-0.7"
      />
      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M52.1,4l0.7,3.4c0.3,1.5,1.8,2.5,3.3,2.2l3.4-0.7"
      />
      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M55.6,21l-0.7-3.4c-0.3-1.5,0.7-3,2.2-3.3l3.4-0.7"
      />
      <path
        stroke={active ? "#cc0c00" : color}
        strokeWidth="1"
        d="M50.8,22l-0.7-3.4c-0.3-1.5-1.8-2.5-3.3-2.2l-3.4,0.7"
      />
    </svg>
  );
}
